// The processed side of the booking review queue (AB#841): GET api/ams/booking-review with
// includeReviewed, paged with skip and take. The pending queue above it still goes through
// reviewApi.ts; this is the read-only list behind the "Show processed" toggle.
import { api } from "@/services/api"
import type { BookingReviewItem } from "@/app/booking-calendar/api/reviewApi"

/** One page of the processed list. */
export interface ProcessedReviewPageArgs {
  skip: number
  take: number
}

export const processedReviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Reviewed items first, newest decision first, then the pending items in the queue's own order:
     * the server's order for `includeReviewed=true`. See `processedPage` for reading a page of it.
     */
    getProcessedReviewItems: builder.query<BookingReviewItem[], ProcessedReviewPageArgs>({
      query: ({ skip, take }) => ({
        url: "/api/ams/booking-review",
        params: { includeReviewed: true, skip, take },
      }),
      // A decision recorded in the queue changes this list; nothing here is worth keeping around.
      keepUnusedDataFor: 0,
    }),
  }),
})

export const { useGetProcessedReviewItemsQuery } = processedReviewApi
